<template>
  <div class="over-money">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="客户名称" prop="customerName">
        <search-select
          v-model="form.customerName"
          type="customer"
          valueField="name"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-date-picker
          v-model="form.year"
          type="year"
          @change="handleYearChange"
          placeholder="选择年">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="月份" prop="month">
        <el-select v-model="form.month" >
          <el-option v-for="(item) of monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch('search')">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleExport" v-permission="'025010601'">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="customerName"
        label="客户名称"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="year"
        label="年份"
        width="160"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="month"
        label="月份"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="rebateGenerateAmount"
        label="返利产生金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="rebateUseAmount"
        label="返利使用金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="260" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button size="mini" @click="lookDetail(scope.$index, scope.row)" v-permission="'025010602'">
            返利产生明细
          </el-button>
          <el-button size="mini" @click="lookDetail(scope.$index, scope.row)" v-permission="'025010603'">
            返利使用明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../components/searchSelect/index'

export default {
  name: 'customerMonthlyDiscountReport',
  components: { SearchSelect },
  data () {
    return {
      form: {
        customerName: '',
        year: new Date().getFullYear().toString(),
        month: ''
      },
      tableData: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      },
      monthList: [
        { value: '', label: '全部' },
        { value: '1', label: '1月' },
        { value: '2', label: '2月' },
        { value: '3', label: '3月' },
        { value: '4', label: '4月' },
        { value: '5', label: '5月' },
        { value: '6', label: '6月' },
        { value: '7', label: '7月' },
        { value: '8', label: '8月' },
        { value: '9', label: '9月' },
        { value: '10', label: '10月' },
        { value: '11', label: '11月' },
        { value: '12', label: '12月' }
      ]
    }
  },
  methods: {
    ...mapActions(['getCustomerMonthlyReport', 'exportCustomerMonthlyList']),
    // 搜索
    handleSearch (val) {
      if (val && val === 'search') {
        this.listState.pageNo = 1
      }
      const params = {
        ...this.form,
        ...this.listState
      }
      this.getCustomerMonthlyReport(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.tableData = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.listState.pageNo = 1
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    },
    // 查询表单，表格重置
    handleReset () {
      this.listState.pageNo = 1
      this.form.year = new Date().getFullYear().toString()
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出
    handleExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportCustomerMonthlyList({ ...this.form }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '客户月度优惠报表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    lookDetail (index, row) {
      this.$router.push({ name: 'differentiatedMarketingFlow', query: { id: row.rebateAccountId } })
    },
    handleYearChange (date) {
      this.form.year = date.getFullYear().toString()
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
  .output-box{
    margin-top: 20px;
    text-align: right;
  }
  .input-page, .select-page{
    width: 98px;
    margin: 0 15px;
  }
  .input-page, .select-page-btn{
    width: 120px;
    margin: 0 15px;
  }
</style>
